module.exports = __webpack_public_path__ + "static/medium_logo-51654067c635d9c357b75c8bf37bfb72.png";